import './Slider.sass';

import { HorizontalScroll } from '$uikit';
import React, { useEffect, useMemo, useRef, useState } from 'react';
import { IcAngleRight16 } from '$assets';
import { useDesktop } from '$hooks';
import { SliderProps } from './Slider.interface';
import { classNames as cn } from '$utils';

export const Slider: React.FC<SliderProps> = ({
  children,
  className,
  scrollIndent,
  headerText,
}) => {
  const scrollRef = useRef<HTMLDivElement>(null);
  const ref = useRef<HTMLDivElement>(null);
  const [scrollEdge, setScrollEdge] = useState<'left' | 'right' | null>('left');
  const [currentScrollIndent, setCurrentScrollIndent] = useState(0);
  const [displayButtons, setDisplayButtons] = useState(false);
  const isDesktop = useDesktop();

  useEffect(() => {
    if (!currentScrollIndent && ref.current) {
      const { offsetWidth } = ref.current;
      setCurrentScrollIndent(scrollIndent || offsetWidth - offsetWidth * 0.1);
    }
  }, [ref.current, scrollIndent]);

  const scrollSliderTo = (left: number) =>
    scrollRef.current?.scrollBy({ left, behavior: 'smooth' });

  const handleScroll = (event) => {
    const { scrollLeft, scrollWidth, offsetWidth } = event.target;

    if (scrollLeft <= 0) {
      setScrollEdge('left');
    } else if (scrollLeft >= scrollWidth - offsetWidth) {
      setScrollEdge('right');
    } else {
      setScrollEdge(null);
    }
  };

  useEffect(() => {
    if (scrollRef.current) {
      setDisplayButtons(scrollRef.current.clientWidth !== scrollRef.current.scrollWidth);
    }
  }, [scrollRef, children]);

  return (
    <div
      ref={ref}
      className={cn('Slider', className, {
        hasHeader: headerText,
      })}
    >
      {isDesktop && displayButtons && scrollEdge !== 'left' && (
        <div
          className="Slider__controls _left"
          onClick={() => scrollSliderTo(-currentScrollIndent)}
        >
          <div className="Slider__controls__btn">
            <IcAngleRight16 />
          </div>
        </div>
      )}
      {headerText && <div className="Slider__header">{headerText}</div>}
      <HorizontalScroll ref={scrollRef} onScroll={handleScroll}>
        {children}
      </HorizontalScroll>
      {isDesktop && displayButtons && scrollEdge !== 'right' && (
        <div
          className="Slider__controls _right"
          onClick={() => scrollSliderTo(currentScrollIndent)}
        >
          <div className="Slider__controls__btn">
            <IcAngleRight16 />
          </div>
        </div>
      )}
    </div>
  );
};
